export const PERMISSIONS = {
    // Voice
    CALL_SVC_BASE: "CALL_VO1",

    // Team Lead
    CALL_SVC_TEAM_LEAD_BASE: "CALL_TL1",

    // Admin
    CALL_SVC_ADMIN_BASE: "CALL_AD1",

    // Treatment Service - Clinics
    TREATMENT_CLINICS_LIST: "TREAT_CL1",
    TREATMENT_CLINICS_FIND: "TREAT_CL2",
    TREATMENT_CLINICS_CREATE: "TREAT_CL3",
    TREATMENT_CLINICS_UPDATE: "TREAT_CL4",
    TREATMENT_CLINICS_DELETE: "TREAT_CL5",

    // Treatment Service - Staff
    TREATMENT_STAFF_LIST: "TREAT_ST1",
    TREATMENT_STAFF_FIND: "TREAT_ST2",
    TREATMENT_STAFF_CREATE: "TREAT_ST3",
    TREATMENT_STAFF_UPDATE: "TREAT_ST4",
    TREATMENT_STAFF_DELETE: "TREAT_ST5",

    // Treatment Service - Treatments
    TREATMENT_TREATMENT_LIST: "TREAT_TR1",
    TREATMENT_TREATMENT_FIND: "TREAT_TR2",
    TREATMENT_TREATMENT_CREATE: "TREAT_TR3",
    TREATMENT_TREATMENT_UPDATE: "TREAT_TR4",
    TREATMENT_TREATMENT_DELETE: "TREAT_TR5",

    // Treatment Service - PRP Sessions
    PRP_SESSIONS_LIST: "PRP_SE1",

    // Treatment Service - Shifts
    TREATMENT_SHIFTS_CALENDAR: "TREAT_SH1",
};
